module.exports = __webpack_public_path__ + "img/home-service-gaocheng.758283cd.png";